import { NewUserGenerationTaskStep } from './NewUserGenerationTaskStep'

export function NewUserFinalStep() {
  return <NewUserGenerationTaskStep />
}
